import { useEffect } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { CURRENCY } from '@/helpers/constants';
import classnames from 'classnames';
import { useWindowSize } from '@/hooks/useWindowSize';
import s from './index.module.scss';

export const MoneyInput = ({
  id = 'money_input',
  value,
  options,
  onChange,
}) => {
  const currencyMask = createNumberMask({
    prefix: CURRENCY,
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: "'",
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 10, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
    ...options,
  });

  const { innerWidth } = useWindowSize();

  function resizeInput() {
    if (innerWidth < 768) return null;
    // eslint-disable-next-line react/no-this-in-sfc
    this.style.width = 10 + (this.value.length + 1) * 10 + 'px';
  }

  useEffect(() => {
    if (!document) return;
    const input = document.querySelector(`#${CSS.escape(id)}`);
    input.addEventListener('input', resizeInput);
    resizeInput.call(input);
    return () => {
      input?.removeEventListener('input', resizeInput);
    };
  }, []);

  const handleChange = e => {
    const value = e.target.value.replaceAll("'", '').replace(CURRENCY, '');
    const validNumber = Number(value) ? Number(value) : 0;
    onChange(validNumber.toString());
  };

  return (
    <div className={s.wrapper}>
      <MaskedInput
        mask={currencyMask}
        placeholder={CURRENCY}
        className={classnames(s.input)}
        onChange={handleChange}
        value={value}
        id={id}
      />
    </div>
  );
};
